import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "active", "children", "disabled", "focus", "value", "label", "data", "onSelect", "badgeTemplate", "prefixTemplate", "suffixTemplate", "dropdownItemArialabel", "multiple", "highlightWords", "role", "showIncreaseArrow"];
// @ts-nocheck
import React, { useCallback, useState } from 'react';
import ClassNames from "classnames";
import { Checkbox } from "../checkbox";
import { highlight } from "./highlight";
import { _uuid } from '../utils';
var DropdownMenuItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    active = props.active,
    children = props.children,
    disabled = props.disabled,
    focus = props.focus,
    value = props.value,
    label = props.label,
    data = props.data,
    onSelect = props.onSelect,
    badgeTemplate = props.badgeTemplate,
    prefixTemplate = props.prefixTemplate,
    suffixTemplate = props.suffixTemplate,
    dropdownItemArialabel = props.dropdownItemArialabel,
    multiple = props.multiple,
    _props$highlightWords = props.highlightWords,
    highlightWords = _props$highlightWords === void 0 ? '' : _props$highlightWords,
    role = props.role,
    _props$showIncreaseAr = props.showIncreaseArrow,
    showIncreaseArrow = _props$showIncreaseAr === void 0 ? false : _props$showIncreaseAr,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useState = useState(false),
    hover = _useState[0],
    setHover = _useState[1];
  var handleClick = useCallback(function (event) {
    // event.preventDefault();
    if (!disabled) {
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, data, event, false);
    }
  }, [onSelect, disabled, value]);
  var onMouseEnter = function onMouseEnter() {
    setHover(true);
  };
  var classNames = ClassNames('ap-option-item', className, {
    'disabled': disabled,
    'moved': focus,
    'active': active,
    'iconLink': hover
  });
  var itemId = "item-" + _uuid(8, 16);
  var badgeElement = null;
  var suffixElement = null;
  if (typeof badgeTemplate === 'function') {
    badgeElement = badgeTemplate(data);
  }
  if (typeof suffixTemplate === 'function') {
    suffixElement = suffixTemplate(data);
  }
  var renderLeft = function renderLeft() {
    var prefixEle;
    if (typeof prefixTemplate === 'function') {
      prefixEle = prefixTemplate(data);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, (multiple || prefixEle) && /*#__PURE__*/React.createElement("div", {
      className: "ap-checkbox-label"
    }, multiple && /*#__PURE__*/React.createElement(Checkbox, {
      tabIndex: -1,
      disabled: disabled,
      checked: active
    }), prefixEle && /*#__PURE__*/React.createElement("div", {
      className: "ap-option-prefix"
    }, prefixEle)), /*#__PURE__*/React.createElement("label", {
      className: "ap-option-label",
      htmlFor: itemId,
      dangerouslySetInnerHTML: {
        __html: highlight(highlightWords, label, false)
      }
    }), /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true
    }, badgeElement));
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    id: itemId,
    role: multiple ? 'checkbox' : role,
    className: classNames,
    "aria-checked": active ? 'true' : null,
    "aria-selected": active ? 'true' : null,
    "aria-disabled": disabled,
    "aria-current": active ? 'true' : null,
    "data-key": value,
    tabIndex: 0,
    onClick: handleClick,
    "aria-label": dropdownItemArialabel ? data.label + ", " + data.descValue : label,
    onMouseEnter: showIncreaseArrow ? function () {
      return !disabled && setHover(true);
    } : undefined,
    onMouseLeave: showIncreaseArrow ? function () {
      return !disabled && setHover(false);
    } : undefined
  }, rest), children ? children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ap-option-left"
  }, renderLeft()), showIncreaseArrow && /*#__PURE__*/React.createElement("span", {
    className: "Appkit4-icon icon-arrow-increase-small-outline"
  }), suffixElement && /*#__PURE__*/React.createElement("div", {
    className: "ap-option-desc",
    "aria-hidden": true
  }, suffixElement)));
});
DropdownMenuItem.displayName = 'DropdownMenuItem';
export default DropdownMenuItem;